module.exports = __webpack_public_path__ + "img/business3.eab7faba.png";